import { useSearchParams } from 'react-router-dom';
import { PasswordResetCard } from '../components/PasswordResetCard';

export function SetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return <PasswordResetCard mode="first-login" token={token} />;
}
